if (!customElements.get('component-faq')) {
  class ComponentFaq extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      this.addEventListener('click', (event) => {
        if (event.target.tagName !== 'SUMMARY') {
          return;
        }

        const parentDetails = event.target.closest('details');
        
        this.querySelectorAll('details[open]').forEach(details => {
          if (details === parentDetails) {
            return;
          }

          details.open = false;
        });
      })
    }
  }

  customElements.define('component-faq', ComponentFaq);
}
